import { HOSTS, ENDPOINTS } from "@/constants";
import { httpClient, type AxiosResponse } from "@/services/httpClient";
import type { User, UserState, RootState } from "@/types";
import type { ActionTree } from "vuex";
import {
  LOAD_CURRENT_USER,
  LOAD_CURRENT_USER_SUCCESS,
  LOAD_CURRENT_USER_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
} from "./mutations";

export const actions: ActionTree<UserState, RootState> = {
  getCurrentUser({ commit }) {
    commit(LOAD_CURRENT_USER);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.USER}/current`).then(
      (response: AxiosResponse<User[]>) => {
        commit(LOAD_CURRENT_USER_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_CURRENT_USER_FAILURE, error.message);
      },
    );
  },
  updateUser({ commit, dispatch }, payload: any) {
    if (payload.load) {
      commit(UPDATE_USER);
    }
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.USER}/${payload?.userId}`, {
        preferences: payload.preferences,
        favoriteProjects: payload.favoriteProjects,
        roles: payload.roles,
      })
      .then(
        (response: AxiosResponse<User[]>) => {
          commit(UPDATE_USER_SUCCESS, response.data);
          if (payload.updateProjects) {
            dispatch("router/fetchClientPlaces", null, {
              root: true,
            });
          }
        },
        (error) => {
          commit(UPDATE_USER_FAILURE, error.message);
        },
      );
  },
  editUser({ commit }, payload: any) {
    commit(UPDATE_USER_SUCCESS, payload);
  },
};
